import React from 'react';
import ToggleSwitchField from 'Shared/form/ToggleSwitchField';
import PropTypes from 'prop-types';

const propTypes = {
    fieldName: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
};

const defaultProps = {
    fieldName: '',
    disabled: false,
    onChange: undefined,
};

const ExcludeToggleFilter = ({ fieldName, disabled, onChange }) => {
    return <ToggleSwitchField fieldName={fieldName} label="Exclude" disabled={disabled} onChange={onChange} />;
};

ExcludeToggleFilter.propTypes = propTypes;
ExcludeToggleFilter.defaultProps = defaultProps;

export default ExcludeToggleFilter;
